/* ============
 * Auth Module
 * ============
 */
import state from './authentication.state';
import mutations from './authentication.mutations';
import getters from './authentication.getters';

export default {
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/app/features/authentication/authentication.store.js